module.exports = __webpack_public_path__ + "img/logo_metamask.3d230802.png";